module.exports = __webpack_public_path__ + "img/star_icon.27f08066.svg";